<h1 class="mt-5 text-center" [translate]="'pages.auth.in-progress'">Authorizing...</h1>
